import { alpha, Theme } from "@mui/material";
import React from "react";

const useStyles = (
  theme: Theme,
  colorMode?: "dark" | "light",
  id?: string,
) => ({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "start",
    flexDirection: "column",
    marginBottom: id ? 0 : 8,
  },
  title: {
    flexGrow: 1,
    fontWeight: 400,
    fontSize: "1.25rem",
  },
  paper: (
    height?: string | number,
    split?: Boolean,
    background?: Boolean,
    noPadding?: Boolean,
  ) => ({
    position: "relative",
    overflow: "visible",
    height: "100%",
    width: "100%",
    padding: background && !noPadding ? 3 : 0,
    // gap: 2,
    display: "flex",
    justifyContent: "start",
    alignItems: "start",
    flexDirection: "column",
    boxShadow:
      theme.palette.mode === "dark"
        ? "none"
        : `0px 2px 5px ${alpha(theme.palette.text.disabled, 0.1)}`,
    backgroundColor: background
      ? theme.palette.background.paper
      : theme.palette.background.default,
  }),
  boxGraphic: (
    direction: "row" | "column" | object,
    separator: boolean | undefined,
  ) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: direction,
    width: "100%",
    height: "100%",
    minHeight: "50px",

    gap: direction === "column" && !separator ? 3 : 1.5,
  }),
  boxTitleSubtitle: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    paddingTop: 3,
    paddingX: 3,
    marginBottom: 3,
    gap: 1,
    width: "100%",
    height: "fit-content",
  },
  subTitle: {
    fontSize: "1rem",
    fontWeight: 400,
    color: "text.secondary",
    lineHeight: 1,
  },
  flotaingButton: {
    position: "fixed",
    bottom: "1rem",
    right: "3rem",
    backdropFilter: "blur(6px)",
    background:
      colorMode === "dark"
        ? alpha(theme.palette.cromatic.green.light, 0.2)
        : alpha(theme.palette.cromatic.green.light, 0.3),
    color: theme.palette.cromatic.green.main,
    boxShadow:
      colorMode === "dark"
        ? "none"
        : `0px 2px 5px ${alpha(theme.palette.text.disabled, 0.2)}`,
    "&:hover": {
      backgroundColor: theme.palette.cromatic.green.light,
      color: theme.palette.cromatic.green.dark,
      opacity: 1,
      cursor: "pointer",
    },
  },
  button: {
    color:
      theme.palette.mode === "dark"
        ? theme.palette.primary.light
        : theme.palette.primary.dark,
    borderColor:
      theme.palette.mode === "dark"
        ? theme.palette.primary.light
        : theme.palette.primary.dark,
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.primary.light, 0.2)
          : alpha(theme.palette.primary.light, 0.2),
    },
  } as React.CSSProperties,
  deleteButton: {
    color:
      theme.palette.mode === "dark"
        ? theme.palette.error.main
        : theme.palette.error.dark,
    borderColor:
      theme.palette.mode === "dark"
        ? theme.palette.error.light
        : theme.palette.error.dark,
    "&:hover": {
      backgroundColor:
        theme.palette.mode === "dark"
          ? alpha(theme.palette.error.light, 0.2)
          : alpha(theme.palette.error.light, 0.2),
    },
  } as React.CSSProperties,
});

export default useStyles;
